import type { NextRouter } from "next/router";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import { hardClientNavigate } from "@Front/Utils/hardClientNavigate";
import type { IItem } from "./index";

function resolveMenuItemHref(item: IItem, linkAttr: string | null): string {
	if (linkAttr) {
		return linkAttr;
	}
	return "link" in item && item.link ? item.link : "";
}

async function shouldSkipClientPushAfterBeforeNavigate(item: IItem, resolvedHref: string): Promise<boolean> {
	if (!("beforeLinkNavigate" in item) || typeof item.beforeLinkNavigate !== "function" || !resolvedHref) {
		return false;
	}
	try {
		return (await item.beforeLinkNavigate(resolvedHref)) === true;
	} catch (error: unknown) {
		LoggerService.error("❌ [MenuItem] beforeLinkNavigate failed", { error });
		return false;
	}
}

function navigateMenuItemLink(item: IItem, href: string, router: NextRouter): Promise<boolean> | void {
	if ("linkNavigationMode" in item && item.linkNavigationMode === "hard") {
		hardClientNavigate(href, "MenuItem.link");
		return;
	}
	return router.push(href);
}

export async function runMenuItemLinkNavigation(params: {
	item: IItem;
	linkAttr: string | null;
	router: NextRouter;
}): Promise<void> {
	const { item, linkAttr, router } = params;
	const resolvedHref = resolveMenuItemHref(item, linkAttr);
	const skipClientPush = await shouldSkipClientPushAfterBeforeNavigate(item, resolvedHref);
	if (linkAttr && !skipClientPush) {
		await navigateMenuItemLink(item, linkAttr, router);
	}
	if ("onClick" in item && item.onClick) {
		item.onClick();
	}
}
